import { ORDER_TYPES } from '@/constants/orderTypes'
import { COURIER_STATUSES, STATUSES } from '@/constants/statuses'

export const DEFAULT_ROUTES_COUNT_PER_PAGE = 24

export const PER_PAGE_ROUTE_OPTIONS = [18, 24, 30, 36]

export const MAX_ORDERS_IN_ROUTE = 5

export const ROUTE_STATUSES = {
    NEW: 'new',
    FORMING: 'building',
    ASSIGNED: 'assigned',
    CONFIRMING: 'confirming',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELED: 'canceled',
}

export const ADDABLE_ORDER_STATUSES = new Set([
    STATUSES.COOKING,
    STATUSES.COLLECTED,
    STATUSES.ON_THE_WAY,
])

export const FORBIDDEN_ORDER_TYPES = new Set([
    ORDER_TYPES.SELF,
    ORDER_TYPES.PREORDER,
    ORDER_TYPES.STAFF_OWN,
    ORDER_TYPES.STAFF_OTHER,
])

export const REMOVABLE_OROUTES_ORDER_STATUSES = new Set([
    ROUTE_STATUSES.FORMING,
    ROUTE_STATUSES.ASSIGNED,
])

export const DRAGGABLE_ROUTE_ORDER_STATUSES = new Set([
    ROUTE_STATUSES.FORMING,
    ROUTE_STATUSES.ASSIGNED,
    ROUTE_STATUSES.IN_PROGRESS,
])

export const NON_DRAGGABLE_ROUTE_ORDER_STATUSES = new Set([
    ROUTE_STATUSES.COMPLETED,
    ROUTE_STATUSES.CANCELED,
])

export const FORMING_OR_ASSIGNED = new Set([
    ROUTE_STATUSES.FORMING,
    ROUTE_STATUSES.ASSIGNED,
])

export const ALLOWED_FROM_FORMING_ASSIGNED = new Set([
    ROUTE_STATUSES.NEW,
    ROUTE_STATUSES.FORMING,
    ROUTE_STATUSES.ASSIGNED,
])

export const CAN_ACCEPT_ORDERS = new Set([
    ROUTE_STATUSES.NEW,
    ROUTE_STATUSES.FORMING,
    ROUTE_STATUSES.ASSIGNED,
    ROUTE_STATUSES.IN_PROGRESS,
])

export const DELETABLE_ROUTE_STATUSES = new Set([
    ROUTE_STATUSES.NEW,
    ROUTE_STATUSES.FORMING,
    ROUTE_STATUSES.ASSIGNED,
])

export const COURIER_SELECT_VISIBLE_STATUSES = new Set([
    ROUTE_STATUSES.FORMING,
    ROUTE_STATUSES.ASSIGNED,
    ROUTE_STATUSES.IN_PROGRESS,
    ROUTE_STATUSES.COMPLETED,
    ROUTE_STATUSES.CANCELED,
])

export const COURIER_SELECT_READONLY_STATUSES = new Set([
    ROUTE_STATUSES.COMPLETED,
    ROUTE_STATUSES.CANCELED,
])

export const SENDABLE_ROUTE_STATUSES = new Set([ROUTE_STATUSES.ASSIGNED])

export const COMPLETABLE_ROUTE_STATUSES = new Set([ROUTE_STATUSES.IN_PROGRESS])

export const COURIER_REASSIGN_CONFIRM_STATUSES = new Set([
    ROUTE_STATUSES.IN_PROGRESS,
])

export const ORDER_STATUSES_WITH_ACTUAL_DELIVERED_DATE = [
    STATUSES.DELIVERED,
    STATUSES.COMPLETED,
]

export const ROUTE_ASSIGNABLE_COURIER_STATUSES = [
    COURIER_STATUSES.AVAILABLE,
    COURIER_STATUSES.ON_WAY,
]
